import modalMissProgMain from './modalMissProgMain';
import modalMissProgProgram from './modalMissProgProgram';
import getPageName from '../getPageName';
import getDataProgram from './getDataProgram';

async function initDropDownsPrograms(pref, requestPrograms) {
  if (!pref) {
    pref = '';
  }

  let filterNoDublicatePrograms = [],
    filterPrograms = [],
    allProgramsRegion = [],
    level = '',
    region = '',
    allProgramsRegionFiltred = [],
    Program = document.getElementById(`Program${pref}`),
    ProgramsHidden = document.querySelectorAll('.program-hidden'),
    Education = document.getElementById(`Education${pref}`),
    Regions = document.getElementById(`Regions${pref}`),
    Direction = document.getElementById(`Direction${pref}`),
    submitButton = document.getElementById(`form-btn${pref}`),
    formCheckbox = document.querySelector(`.form__checkboxs${pref}`),
    shortUrl = getPageName();

  /* FLOW-11265 срабатывание цели один раз при выборе региона и программы */
  let selectedOnceRegion = false,
    selectedOnceProgram = false;

  /* Общий уникальный массив с операторами */
  let allPrograms = requestPrograms;

  /* Выбор региона и программ в зависимости от региона */
  if (Regions !== null) {
    Regions.onchange = function (e) {
      if (!selectedOnceRegion) {
        ym(94760218, 'reachGoal', 'geo');
        selectedOnceRegion = true;
      }

      region = e.target.value;
      $(`#Direction${pref}`).val(null).trigger('change');

      /* Фильтрация общего массива в зависимости от выбранного региона */
      allProgramsRegionFiltred = allPrograms.filter((item) =>
        item.regions.some((it) => it.region_id == region)
      );

      /* Логика по отсеиванию программ с одинаковыми shortname, у которых нет в данном регионе задачи */
      filterNoDublicatePrograms = structuredClone(allProgramsRegionFiltred);
      
      /* Добавление в переменную всех возможных программ для данного региона для отслеживания логики вывода модального окна с нужным сообщением */
      allProgramsRegion = [];
      allProgramsRegion = structuredClone(filterNoDublicatePrograms);

      /* Сценарии вывода программ для страниц с полем Выбора программы и без него */
      if (!ProgramsHidden.length) {
        logicEducationFields();
      } else {
        logicEducationFields();
        setAttrforSingleField();
        logicModalPageProgram();
      }
    };
  }

  /* Выбор уровня образования */
  if (Education !== null) {
    Education.onchange = function (e) {
      $(`#Program${pref}`).val(null).trigger('change');
      level = e.target.value;

      logicEducationFields();
      logicModalPageProgram();
    };
  }

  /* Выбор направления */
  if (Direction !== null) {
    Direction.onchange = function () {
      /* Фильтрация массива (с выбранным регионом) по направлению */
      const filterDirectionPrograms = structuredClone(allProgramsRegion).filter(
        (item) => item.direction_id == this.value
      );

      /* Убираем дубли по shortName и присваиваем рандомно оператора */
      filterNoDublicatePrograms = filterDirectionPrograms.filter(
        (item, idx, arr) => {
          return arr.findIndex((it) => it.shortname === item.shortname) === idx;
        }
      );

      logicEducationFields();
    };
  }

  /* Выбор программы. Получаем ссылку на РВР и устанавливаем ее в качестве аттрибута */
  if (!ProgramsHidden.length && Program) {
    Program.onchange = function (e) {
      if (!selectedOnceProgram && e.target.value != '') {
        selectedOnceProgram = true;
        ym(94760218, 'reachGoal', 'prog');
      }

      let data = getDataProgram(filterNoDublicatePrograms, e, region);
      
      /* Добавление аттрибута ссылки на РВР */
      e.target.options[e.target.selectedIndex].setAttribute(
        'linkrvr', data?.link
      );
      
      /* Добавление аттрибута оператора */
      e.target.options[e.target.selectedIndex].setAttribute(
        'operator', data?.operator
      );
      
      /* Добавление аттрибута id программы */
      e.target.options[e.target.selectedIndex].setAttribute(
        'program_id', data?.program_id
      );
    };
  }

  /* Логика вывода модальных окон на странице программы */
  function logicModalPageProgram() {
    let url = location.href.split('/');

    /* Если не сайт программы, прекращаем выполнение функции */
    if (!url.includes('program')) {
      return;
    }

    if (region && level) {
      let statusPO = false,
        statusDPO = false;

      filterNoDublicatePrograms.forEach((program) => {
        if (program.shortname == shortUrl) {
          statusPO = true;
        }
      });

      filterPrograms.forEach((program) => {
        if (program.shortname == shortUrl) {
          statusDPO = true;
        }
      });

      /* Модальное окно отсутствия программ по выбранному региону для страниц программ */
      modalMissProgProgram(
        filterNoDublicatePrograms,
        region,
        submitButton,
        formCheckbox,
        shortUrl,
        [statusPO, statusDPO]
      );
    }
  }

  /* Логика полей в зависимости от выбора уровня образования */
  function logicEducationFields() {
    if (level == 1) {      
      filterPrograms = filterNoDublicatePrograms.filter((item) => item.level == "vocational");
    } else {
      filterPrograms = filterNoDublicatePrograms;
    }
    
    if (!ProgramsHidden.length) {
      /* Модальное окно отсутствия программ по выбранному региону для главной страницы */
      modalMissProgMain(
        Regions,
        filterPrograms,
        filterNoDublicatePrograms,
        allProgramsRegion
      );

      /* Создаем option только на главной */
      renderOptions(filterPrograms);
    }
  }

  /* Создаем нужные options */
  function renderOptions(arr) {
    [...Program.children].map((item, idx) => {
      if (idx > 0) {
        item.remove();
      }
    });

    arr.forEach((item) => {
      let option = new Option(item.name, item.name, false, false);
      option.setAttribute('shortName', item.shortname);

      Program.append(option);
    });
  }

  /* Если страница программы, добавляем необходимые аттрибуты к скрытым полям */
  function setAttrforSingleField() {
    ProgramsHidden.forEach((programHidden) => {
      programHidden.setAttribute('shortname', shortUrl);

      let data = getDataProgram(filterNoDublicatePrograms, programHidden, region);

      /* Добавление названия программы в форму */          
      if (data?.name) {
        programHidden.value = data.name; 
      }   
      
      /* Добавление данных по программе */      
      programHidden.setAttribute(
        'linkrvr', data?.link
      );
      programHidden.setAttribute(
        'operator', data?.operator
      );
      programHidden.setAttribute(
        'program_id', data?.program_id
      );
    });
  }
}

export default initDropDownsPrograms;
